import { render, staticRenderFns } from "./changeCat.vue?vue&type=template&id=67374cec&"
import script from "./changeCat.vue?vue&type=script&lang=js&"
export * from "./changeCat.vue?vue&type=script&lang=js&"
import style0 from "./changeCat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports